import React, { Component, Suspense } from "react";
import { withLocalize } from "react-localize-redux";
import "../styles/base/_base.scss";
import "../styles/components/_home.scss";

// import ArtistBio from "../components/Banner/artistBio";
import axios from "axios";
/* `ToastContainer` -ийг ЭНД БҮРТГЭХГҮЙ. Апп даяар нэг нь аль хэдийн
   бий: Header -> Login (`components/Login/login.js`) хуудас болгон дээр
   түүнийг угсардаг бөгөөд CSS-ийг нь ч татдаг. Хоёр дахийг нэмбэл нэг
   `toast()` дуудлага ХОЁУЛАНД нь зурагдаж, мэдэгдэл давхардана. */
import { toast } from "react-toastify";
import { Translate } from "react-localize-redux";
import Hero from "../components/Home/Hero";

// Lazy load heavy components
const Slider = React.lazy(() => import("../components/Home/Slider"));
const Subscription = React.lazy(() => import("../components/Home/Subscription"));
const Faq = React.lazy(() => import("./faq"));
const ServicePage = React.lazy(() => import("../components/Home/ServicePage"));

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: "default",
      subscription: "",
      errorMessage: "",
      errorModal: false,
      isLoading: false,
      landingData: null,
    };
  }

  componentDidMount() {
    // this.fetchLandingData();
    this.notifyIfRedirected();
  }

  /**
   * /premium -ээс шидэгдсэн шалтгааныг мэдэгдэнэ.
   *
   * Идэвхтэй багцтай хэрэглэгчийг `containers/premium.js` нүүр рүү
   * буцаадаг. Тайлбаргүй бол тэр зүгээр л "холбоос ажиллахгүй байна"
   * гэж ойлгоно.
   *
   * Мэдэгдлээ үзүүлмэгц хаягнаас тэмдгийг АРЧИНА — хуудсаа сэргээхэд
   * дахин гарах учиргүй.
   */
  notifyIfRedirected = () => {
    try {
      const params = new URLSearchParams(window.location.search || "");
      if (!params.has("activeSubscription")) return;

      /* Тэмдгийг МЭДЭГДЛЭЭС ӨМНӨ арчина: энэ компонент нэг ачаалалтад
         хоёр удаа mount хийгдвэл (эсвэл дахин дуудагдвал) хоёр дахь нь
         тэмдгийг олохгүй тул мэдэгдэл ДАВХАРДАХГҮЙ. */
      params.delete("activeSubscription");
      const rest = params.toString();
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}${rest ? `?${rest}` : ""}`,
      );

      /* `toastId` — давхардлын хоёр дахь хамгаалалт. Ижил id-тай
         мэдэгдэл нэгээс олон удаа гарахгүй. */
      toast.info(<Translate id="content.already-subscribed" />, {
        toastId: "active-subscription",
      });
    } catch (err) {
      /* хаяг уншиж чадаагүй бол мэдэгдэлгүй өнгөрнө */
    }
  };

  fetchLandingData = async () => {
    this.setState({ isLoading: true });
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/landing-page`);
      const resHomeCard = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/landing-page/contents/list/ALL`,
      );
      this.setState({
        landingData: res.data,
        cardData: resHomeCard.data,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        errorMessage: "Failed to fetch landing page data",
        isLoading: false,
      });
      console.error("Failed to fetch landing page data:", error);
    }
  };

  render() {
    const { errorMessage } = this.state;
    // if (isLoading) return <div>Loading...</div>;
    if (errorMessage) return <div>{errorMessage}</div>;

    // console.log("Landing Data:", landingData?.result);

    return (
      <div className="home-page">
        <Hero />
        <Suspense fallback={<div style={{ minHeight: '400px' }} />}>
          <Slider />
        </Suspense>
        <Suspense fallback={<div style={{ minHeight: '300px' }} />}>
          <Subscription />
        </Suspense>
        <Suspense fallback={<div style={{ minHeight: '500px' }} />}>
          <ServicePage />
        </Suspense>
        <Suspense fallback={<div style={{ minHeight: '400px' }} />}>
          <Faq />
        </Suspense>
      </div>
    );
  }
}

export default withLocalize(Home);
